/**
 * Get paged files
 * @param {array} files
 * @param {number} page
 * @param {number} pageLimit
 * @returns {object}
 */
export default function getPagedFiles(files = [], page = 1, pageLimit = 12) {
  const pageLimitInt = parseInt(pageLimit, 10);
  const pageCount = Math.ceil(files.length / pageLimitInt);

  const start = (page - 1) * pageLimitInt;
  const end = start + pageLimitInt;
  const paged = files.slice(start, end);

  return { paged, pageCount };
}
